module.exports = __webpack_public_path__ + "img/65.5ebfde5a.jpg";